module.exports = __webpack_public_path__ + "media/images/smart_phone/shares/202001/logo_aichi-2f8ddb4054024708c5c7d840004e0c47.png";